import { render, staticRenderFns } from "./CertsCard.vue?vue&type=template&id=70d76482&scoped=true"
import script from "./CertsCard.vue?vue&type=script&lang=js"
export * from "./CertsCard.vue?vue&type=script&lang=js"
import style0 from "./CertsCard.vue?vue&type=style&index=0&id=70d76482&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70d76482",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\wamp64\\www\\signar-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70d76482')) {
      api.createRecord('70d76482', component.options)
    } else {
      api.reload('70d76482', component.options)
    }
    module.hot.accept("./CertsCard.vue?vue&type=template&id=70d76482&scoped=true", function () {
      api.rerender('70d76482', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/certificados/CertsCard.vue"
export default component.exports